import Cookie from "js-cookie";
import { Dialog, Toast } from "@xp-design/mobile";
import axios from "@xpeng/union-login";
import { getDeviceId, getClientEnv, getBrowserEnv } from "./tools";

export const key = "xp_charge_wx_h5"; // 用户中心应用KEY

let baseUrl = ""; // 请求接口前辍
const env = getClientEnv();
const domainMap = {
  // 'test': 'http://logan-gateway.test.logan.xiaopeng.local/xp-charge-boot',
  test: "http://chargegateway.test.xiaopeng.local",
  // test: "http://localhost:8080",
  deploy: "https://chargegateway.deploy-test.xiaopeng.com",
  product: "https://chargegateway.xiaopeng.com",
};
baseUrl = domainMap[env];

const cancelAppLogin = () => {
  // 客户端取消登录回调
  window.location.reload();
};

/**
 * 弹出APP登录界面后回调方法
 * @param callback
 */
const popupAppLogin = (callback: () => void) => {
  callback();
  Dialog.alert({
    title: "如未成功登录，请重试",
    onConfirm: () => {
      window.location.reload();
    },
  });
};

/**
 * 显示服务端报错信息
 * @param err
 */
const showError = (err: {
  response: {
    data: {
      msg: string;
    };
  };
  message: string;
}) => {
  if (err.response && err.response.data && err.response.data.msg) {
    Toast.show({
      content: err.response.data.msg,
    });
  } else {
    if (err.message != "Network Error") {
      Toast.show({
        // content: err.message,
        content: "活动太火爆，请稍后重试",
      });
    }
  }
};

/**
 * 处理GET请求参数
 * @param params
 */
const processGetParams = (params: Record<string, any>) => {
  params.redirectUrl = window.location.href;
  params.preUid = params.preUid || params.uid || "";
  if (Cookie.get("isTest") == "true") {
    params.test = true;
  }
  // processGetParams在联登sdk中任意端都会执行，在APP、小程序环境中，该方法执行前params参数里面已经通过各端传入preUid，所以在这里写进会话存储，供当前页使用
  if (params.preUid) {
    sessionStorage.setItem("sessionUid", params.preUid);
  }

  return params;
};

/**
 * 处理POST请求参数
 * @param params
 */
const processPostParams = (params: Record<string, any>) => {
  params.redirectUrl = window.location.href;
  return params;
};

const processPostUrlParams = (params: Record<string, any>) => {
  params.redirectUrl = window.location.href;
  params.preUid = params.preUid || params.uid || "";
  if (Cookie.get("isTest") == "true") {
    params.test = true;
  }
  const urlParams = { ...params };
  // POST请求url去除非联登所需参数，防止业务参数携带到url上
  Object.keys(urlParams).forEach((key) => {
    ![
      "uid",
      "openid",
      "preUid",
      "code",
      "frontRedirect",
      "redirectUrl",
    ].includes(key) && delete urlParams[key];
  });

  return urlParams;
};

/**
 * 处理返回参数
 * @param res
 */
const returnData = (res: any) => {
  const { data } = res;
  return data;
};

/**
 * 获取自定义头部信息
 * XP-Client-Type根据当前环境设置 --> 5：微信浏览器，6：小程序，7：APP，8：其他WEB浏览器
 */
const formatHeader = () => {
  let XpClientType = 8;

  const { isXPApp, isWX, isWXApp, isMyApp } = getBrowserEnv();

  if (isXPApp) {
    XpClientType = 7;
  } else if (isWX && !isWXApp) {
    XpClientType = 5;
  } else if (isWXApp || isMyApp) {
    XpClientType = 6;
  } else {
    XpClientType = 8;
  }

  const sessionUid =
    sessionStorage.getItem("sessionUid") || Cookie.get("wasxuid_r") || "";
  return {
    // 'XP-Uid': '6935665',//uat
    // 'XP-Uid': '1147170', // 测试
    // 'XP-Uid': '8132807',
    // 'XP-Uid': '8132888',
    // 'XP-Uid': '8117843',
    "XP-Uid": sessionUid,
    "XP-Appid": key,
    "XP-DeviceId": getDeviceId("xp-charge-web") || "",
    "XP-Xid": "",
    "XP-Nonce": Date.now(),
    "XP-Client-Type": XpClientType,
  };
};

const axiosInstance = axios({
  key,
  baseUrl,
  cancelAppLogin,
  showError,
  processGetParams,
  processPostParams,
  processPostUrlParams,
  getMiniProgramLoginUrl: function () {
    return `/pages/user/login?appId=${key}&webviewUrl=${encodeURIComponent(
      window.location.href,
    )}`;
  },
  popupAppLogin,
  returnData,
});

// 添加error的sentry监控
const originGet = axiosInstance.get;
axiosInstance.get = function get(url: string, params?: any, options?: any) {
  // Sentry.addBreadcrumb({
  //   type: 'network-request',
  //   message: `${url}`,
  //   data: {
  //     url,
  //     params,
  //     options
  //   }
  // });
  return originGet.call(axiosInstance, url, params, options).catch((e) => {
    // Sentry.captureException(e)
    throw e;
  });
};
const originPost = axiosInstance.post;
axiosInstance.post = function post(url: string, params?: any, options?: any) {
  // Sentry.addBreadcrumb({
  //   type: 'network-request',
  //   message: `${url}`,
  //   data: {
  //     url,
  //     params,
  //     options
  //   }
  // });
  return originPost.call(axiosInstance, url, params, options).catch((e) => {
    // Sentry.captureException(e)
    throw e;
  });
};

export default {
  get: (url: string, params = {}, options = {}) => {
    Object.assign(options, { headers: formatHeader(), withCredentials: true });
    console.log("params", url, params);
    return axiosInstance.get(url, params, options);
  },
  post: (url: string, params = {}, options = {}) => {
    console.log("params", url, params);
    Object.assign(options, { headers: formatHeader(), withCredentials: true });
    return axiosInstance.post(url, params, options);
  },
};
